// Auto generated file, do not manually modify!
// com.hotpads.admanagement.api.web.external.handler.AdManagementEliseAiApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  AdManagementEliseAiApiHandler_getEliseStatuses,
  AdManagementEliseAiApiHandler_getEliseStatuses_Path,
  AdManagementEliseAiApiHandler_hasEliseSfhEnabled,
  AdManagementEliseAiApiHandler_hasEliseSfhEnabled_Path,
  AdManagementEliseAiApiHandler_updateAllEliseAiStatuses,
  AdManagementEliseAiApiHandler_updateEliseAiStatus,
} from '@zg-rentals/ts-ad-management-client';

import type { PropertyEliseDto } from '@zg-rentals/ts-ad-management-client';

interface UpdateAllEliseAiStatusesParams {
  isEliseAiEnabled: boolean;
}
interface UpdateEliseAiStatusParams {
  isEliseAiEnabled: boolean;
  propertyListingAlias: string;
}

export type AdManagementEliseAiApiHandler_getEliseStatuses_Options = UseQueryOptions<
  Array<PropertyEliseDto>,
  unknown,
  Array<PropertyEliseDto>,
  readonly [string]
>;

const AdManagementEliseAiApiHandler_getEliseStatuses_GetKey = () =>
  [AdManagementEliseAiApiHandler_getEliseStatuses_Path] as const;

export const AdManagementEliseAiApiHandler_getEliseStatuses_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: AdManagementEliseAiApiHandler_getEliseStatuses_GetKey(),
    queryFn: () => AdManagementEliseAiApiHandler_getEliseStatuses(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Grabs all the mfh paid property thumbnails and elise statuses for a user
 */
export const useAdManagementEliseAiApiHandler_getEliseStatuses = ({
  httpClient,
  ...options
}: Omit<AdManagementEliseAiApiHandler_getEliseStatuses_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...AdManagementEliseAiApiHandler_getEliseStatuses_queryOptions({ httpClient }),
    ...options,
  });
};
useAdManagementEliseAiApiHandler_getEliseStatuses.getKey = AdManagementEliseAiApiHandler_getEliseStatuses_GetKey;

export type AdManagementEliseAiApiHandler_hasEliseSfhEnabled_Options = UseQueryOptions<
  boolean,
  unknown,
  boolean,
  readonly [string]
>;

const AdManagementEliseAiApiHandler_hasEliseSfhEnabled_GetKey = () =>
  [AdManagementEliseAiApiHandler_hasEliseSfhEnabled_Path] as const;

export const AdManagementEliseAiApiHandler_hasEliseSfhEnabled_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: AdManagementEliseAiApiHandler_hasEliseSfhEnabled_GetKey(),
    queryFn: () => AdManagementEliseAiApiHandler_hasEliseSfhEnabled(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Returns if a user is part of the eliseAI SFH rollout
 */
export const useAdManagementEliseAiApiHandler_hasEliseSfhEnabled = ({
  httpClient,
  ...options
}: Omit<AdManagementEliseAiApiHandler_hasEliseSfhEnabled_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...AdManagementEliseAiApiHandler_hasEliseSfhEnabled_queryOptions({ httpClient }),
    ...options,
  });
};
useAdManagementEliseAiApiHandler_hasEliseSfhEnabled.getKey = AdManagementEliseAiApiHandler_hasEliseSfhEnabled_GetKey;

export interface AdManagementEliseAiApiHandler_updateAllEliseAiStatuses_Args {
  getParams: UpdateAllEliseAiStatusesParams;
}

export type AdManagementEliseAiApiHandler_updateAllEliseAiStatuses_Options = UseMutationOptions<
  void,
  unknown,
  AdManagementEliseAiApiHandler_updateAllEliseAiStatuses_Args
>;

/**
 * Queues updates for all user eliseAi statuses to chosen boolean. Tentative - Test on smaller users first! - Note: Since propertyNum can be large, doesn't queue for realtime refresh
 */
export const useAdManagementEliseAiApiHandler_updateAllEliseAiStatuses = ({
  httpClient,
  ...options
}: Omit<AdManagementEliseAiApiHandler_updateAllEliseAiStatuses_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: AdManagementEliseAiApiHandler_updateAllEliseAiStatuses_Args) =>
      AdManagementEliseAiApiHandler_updateAllEliseAiStatuses(args.getParams, httpClient),
  });
};

export interface AdManagementEliseAiApiHandler_updateEliseAiStatus_Args {
  getParams: UpdateEliseAiStatusParams;
}

export type AdManagementEliseAiApiHandler_updateEliseAiStatus_Options = UseMutationOptions<
  void,
  unknown,
  AdManagementEliseAiApiHandler_updateEliseAiStatus_Args
>;

/**
 * Updates a given listingAlias eliseAi status
 */
export const useAdManagementEliseAiApiHandler_updateEliseAiStatus = ({
  httpClient,
  ...options
}: Omit<AdManagementEliseAiApiHandler_updateEliseAiStatus_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: AdManagementEliseAiApiHandler_updateEliseAiStatus_Args) =>
      AdManagementEliseAiApiHandler_updateEliseAiStatus(args.getParams, httpClient),
  });
};
